module.exports = __webpack_public_path__ + "static/media/copy.b5ab4372.svg";